import type { Stay, Traveler } from './types'

/**
 * Titular de la reserva con lo que da E1 (inventario D23): el primer registrado adulto que no se puede borrar
 * (`adult && !canDelete`). Nunca un menor. null si el titular aún no se ha registrado.
 */
export function holderTraveler(stay: Pick<Stay, 'registration'>): Traveler | null {
  return stay.registration.travelers.find((tr) => tr.isAdult && !tr.canDelete) ?? null
}

/** Email de contacto de la reserva: el del titular o, si no lo tiene, el del primer adulto registrado. Nunca el de un menor. */
export function adultContactEmail(stay: Pick<Stay, 'registration'>): string | null {
  return holderTraveler(stay)?.details.email || stay.registration.travelers.find((tr) => tr.isAdult && tr.details.email)?.details.email || null
}
